export default "__VITE_ASSET__BSq2OL06__"